import { z } from 'zod';

export const AdminWorkspaceRoleItemSchema = z.object({
  id: z.uuid(),
  workspaceId: z.uuid(),
  name: z.string().min(1),
  createdAt: z.iso.datetime(),
});

export type AdminWorkspaceRoleItem = z.infer<typeof AdminWorkspaceRoleItemSchema>;

export const ListAdminWorkspaceRolesPathParamsSchema = z.object({
  workspaceId: z.uuid(),
});

export const ListAdminWorkspaceRolesResponseSchema = z.object({
  data: z.array(AdminWorkspaceRoleItemSchema),
});

export type ListAdminWorkspaceRolesResponse = z.infer<typeof ListAdminWorkspaceRolesResponseSchema>;
